import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { EventoCalendario } from '../EventoCalendario';
import { FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { CronogramaViewModel } from '../../../../viewmodel/CronogramaViewModel';

interface ModalConclusaoProps {
    processoId: string;
    cronogramaId: string;
    show: boolean;
    handleClose: () => void;
    atividadesUsuario: EventoCalendario[];
    setAtividadesUsuario: React.Dispatch<React.SetStateAction<EventoCalendario[]>>;
}

const ModalConclusao: React.FC<ModalConclusaoProps> = ({ processoId, cronogramaId, show, handleClose, atividadesUsuario, setAtividadesUsuario }) => {

    const handleSave = async () => {
        try {
            const status = await CronogramaViewModel.concluirCronograma(processoId, cronogramaId);
            if (status >= 200 && status < 300) {
                toast.success('Cronograma definido com sucesso');
                handleClose();
            } else {
                toast.error('Erro ao definir cronograma.');
            }
        } catch (error) {
            toast.error('Erro ao definir cronograma.');
        }
    };

    const handleDelete = (index: number) => {
        const newAtividades = atividadesUsuario.filter((_, i) => i !== index);
        setAtividadesUsuario(newAtividades);
    };

    const atividadesOrdenadas = [...atividadesUsuario].sort((a, b) => a.start.getTime() - b.start.getTime());

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Definições do Cronograma</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ overflowX: 'auto' }}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Título da Atividade</th>
                                <th>Data</th>
                                <th>Horário de Início</th>
                                <th>Remover</th>
                            </tr>
                        </thead>
                        <tbody>
                            {atividadesOrdenadas.map((atividade, index) => (
                                <tr key={atividade.id}>
                                    <td style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                                        {atividade.title}
                                    </td>
                                    <td>
                                        {atividade.start.toLocaleDateString()}
                                    </td>
                                    <td>
                                        {atividade.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </td>                                    
                                    <td style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                        <Button variant="danger" size="sm" onClick={() => handleDelete(index)}>
                                            <FaTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleSave}>
                    Concluir Cronograma
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalConclusao;
